import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { deepCompare } from "@website/utils/deep-compare";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import styles from "@website/widget/login/components/header/header.module.scss";
import { HeaderPropertiesType } from "@website/widget/login/components/header/header.types";
import { FORCE_LOGIN_KEY } from "@website/widget/login/constants";
import { FC, memo, PropsWithChildren } from "react";

const Header: FC<PropsWithChildren<HeaderPropertiesType>> = (properties) => {
  const { className, id, title, onBack, onClose: onCloseModal } = properties;
  const router = useCompatRouter();
  const isForceLogin = Boolean(router.query[FORCE_LOGIN_KEY]);
  const onClose = isForceLogin ? null : onCloseModal;

  return (
    <div className={`${styles["container"]} ${className ?? ""}`} id={id ?? ""}>
      {onBack && (
        <Button
          EndIcon={<MaterialIcon name="arrow_forward" />}
          color="neutral"
          equalDimension
          onClick={onBack}
          variant="text"
        />
      )}
      <h4 className={styles["title"]}>{title}</h4>
      {onClose && (
        <Button
          EndIcon={<MaterialIcon name="close" />}
          color="neutral"
          equalDimension
          onClick={onClose}
          variant="text"
        />
      )}
    </div>
  );
};

const HeaderMemoized = memo(Header, deepCompare);
export { HeaderMemoized as Header };
